<template>
  <div>
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row v-if="isSystemAdmin() || creatable">
              <b-col cols="12">
                <div class="text-right">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.menuSaveModal
                    variant="success"
                    @click="onCreateMenu"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm menu
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-0">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  mode="remote"
                  :columns="columns"
                  :rows="menus"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  :line-numbers="true"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'status'">
                      {{ getStatusName(props.row.status) }}
                    </span>

                    <span v-else-if="props.column.field === 'type'">
                      {{ getTypeName(props.row.type) }}
                    </span>

                    <span v-else-if="props.column.field === 'action'">
                      <b-button
                        v-if="isSystemAdmin() || updatable"
                        v-b-modal.menuSaveModal
                        variant="primary"
                        class="btn-icon"
                        size="sm"
                        @click="onEditMenu(props.row)"
                      >
                        <feather-icon icon="Edit2Icon" />
                      </b-button>
                      <b-button
                        v-if="isSystemAdmin() || deletable"
                        variant="danger"
                        class="btn-icon"
                        style="margin-left: 6px"
                        size="sm"
                        @click="onDeleteMenu(props.row)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </span>

                    <span v-else-if="props.column.field === 'icon'">
                      <b-card
                        v-b-tooltip.hover.top="props.row.icon"
                        class="icon-card cursor-pointer text-center mb-2 mx-50"
                      >
                        <div class="icon-wrapper">
                          <feather-icon
                            :icon="props.row.icon"
                            size="10"
                          />
                        </div>
                        <b-card-text class="icon-name text-truncate mb-0 mt-1">
                          {{ props.row.icon }}
                        </b-card-text>
                      </b-card>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <MenuSave
      ref="menuSaveModalRef"
      :menu="currentMenu"
      @succeed="onSucceed"
    />
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow, BCardText, VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import MenuSave from '@/views/authorization/menu/MenuSave.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { MENU_TYPES, STATUSES } from '@/const/status'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'

export default {
  name: 'Menu',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    MenuSave,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    BCardText,
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        title: '',
        status: '',
        sort: '',
      },
      currentMenu: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'Tên menu',
          field: 'title',
          filterOptions: {
            placeholder: 'Nhập tên menu',
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          width: '20%',
          thClass: 'text-center',
        },
        {
          label: 'Hình ảnh',
          field: 'icon',
          sortable: false,
          width: '10%',
          thClass: 'text-center',
        },
        {
          label: 'Tag',
          field: 'tag',
          sortable: false,
          width: '10%',
          thClass: 'text-center',
        },
        {
          label: 'Màu sắc tag',
          field: 'tagVariant',
          sortable: false,
          width: '10%',
          thClass: 'text-center',
        },
        {
          label: 'Loại',
          field: 'type',
          filterOptions: {
            placeholder: 'Chọn loại menu',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: MENU_TYPES.map(status => ({ value: status.value, text: status.label })),
          },
          width: '15%',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          filterOptions: {
            placeholder: 'Chọn trạng thái',
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: [
              { value: 1, text: 'Hoạt động' },
              { value: 0, text: 'Không hoạt động' },
            ],
          },
          width: '15%',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Thứ tự',
          field: 'orderNo',
          sortable: true,
          width: '10%',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '10%',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      menus: 'menu/menus',
      totalRows: 'menu/totalRows',
    }),
    creatable() {
      return hasPermissionForResource(PermissionCode.CREATE, ResourceCode.MENU)
    },
    updatable() {
      return hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.MENU)
    },
    deletable() {
      return hasPermissionForResource(PermissionCode.DELETE, ResourceCode.MENU)
    },
  },
  async created() {
    await this.getMenusFromStore()
  },
  methods: {
    isSystemAdmin,
    ...mapActions({
      getMenus: 'menu/getMenus',
      deleteMenu: 'menu/deleteMenu',
    }),
    onCreateMenu() {
      this.currentMenu = undefined
    },
    onEditMenu(menu) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = menu
      this.currentMenu = rest
    },
    onDeleteMenu(menu) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa menu <span class="text-danger">${menu.title}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteMenu(menu.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'CheckIcon',
                    variant: 'success',
                  },
                })
                try {
                  await this.getMenus(this.filter)
                } catch (e) {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `[${e.code}] ${e.message}`,
                      icon: 'XCircleIcon',
                      variant: 'danger',
                    },
                  })
                }
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: message,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            }
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getMenusFromStore()
    },
    async getMenusFromStore() {
      this.isLoading = true
      try {
        await this.getMenus(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getMenusFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'title') this.updateParams({ sort: `1_${type}` })
        else this.updateParams({ sort: `2_${type}` })
      }
      await this.getMenusFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'title')) this.updateParams({ title: columnFilters.title })
      if (Object.hasOwn(columnFilters, 'type')) this.updateParams({ type: columnFilters.type })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getMenusFromStore()
    },
    getStatusName(value) {
      return STATUSES.find(status => status.value === value).label
    },
    getTypeName(value) {
      return MENU_TYPES.find(type => type.value === value).label
    },
    async onSucceed() {
      await this.getMenusFromStore()
    },
  },
}
</script>

<style scoped>

</style>
